import { useLocationContext } from 'state/location';

export const useGetUrlSearchParam = (value: string) => {
  const {
    location: { search },
  } = useLocationContext();
  const params = new URLSearchParams(search);
  return params.get(value);
};
